//status for loading, combine into one page shared across modules

import React from 'react'
import { StyleSheet } from 'react-native'
import Animated, { FadeInDown } from 'react-native-reanimated'

import * as pocketPick from '@/router/(root)/pocketPick/pocketPickModule'
import { PocketPickAdminControls as AdminControls } from "@/components/Mini/AdminControls"
import { PocketPickBackground as Background } from "@/components/Mini/Background"
import { PocketPickRules as Rules } from "@/components/Mini/Rules"
import { PocketPickHeader as Header } from "@/components/Mini/Header"
import { PocketPickStatBlocks as StatBlocks } from "@/components/Mini/StatBlocks"
import { PocketPickFooter as Footer } from "@/components/Mini/EntryScreenFooter"
import { PrimaryBtn, SecondaryBtn } from "@/components/Mini/Button"

import type { MinigameModule } from '@/types/minigameModule'

/*import { 
  PrimaryBtn, 
  SecondaryBtn, 
  AdminControls, 
  Background, 
  StatusBar, 
  Header,
  Rules, 
  StatBlocks
} from "@/screens/pocketPick/components"*/



export const PocketPickEntryScreen = () => {

  const { isAdmin, isSuperAdmin, } = pocketPick.usePocketPickUser()
  
  const gameName = pocketPick.useStore(s => s.GAME_NAME)

  const handleClose = pocketPick.useHandleClose()

  const showAdminControls = isAdmin || isSuperAdmin

  return (
    <Background>
          
          <Header title={gameName} handler={handleClose} />

          {showAdminControls && (
            <AdminControls />
          )}

          <Animated.View entering={FadeInDown.springify()} style={styles.body}>

            <Rules />

            <StatBlocks />

            <LeaderboardBtn m={pocketPick}/>

          </Animated.View>

          <Footer />

    </Background>
  )
}


function LeaderboardBtn({ m }: { m: MinigameModule }) {

  const handleLeaderboard = m.useHandleLeaderboard()
  const theme = m.useStore(s => s.theme)

  return (
    <SecondaryBtn theme={theme} handler={handleLeaderboard} label="Leaderboard" />
  )
}



const styles = StyleSheet.create({
  fill: { flex: 1 },
  body: { flex: 1, paddingHorizontal: 24, justifyContent: 'center', gap: 40 }
})




